export const ICON_SIZE = [40, 40]

export const ICON_ANCHOR = [20, 40]